import { CommonService } from './../../../shared/services/common-service';
import { PaymentModel, defaultLanguage, tutorialVideo } from './../../constant';
import { Subscription } from 'rxjs/Rx';
import { Component, OnInit, OnChanges, HostListener, AfterViewInit, Inject, EventEmitter, Output } from '@angular/core';
import { DOCUMENT, DomSanitizer } from '@angular/platform-browser';

import { LocalStorageService } from 'angular-2-local-storage';
import { Router, ActivatedRoute, Params, Event as NavigationEvent, RoutesRecognized, NavigationEnd } from '@angular/router';
import { CookieNames, AuthTypes, BasicRoutes, LanguageSelector, AlertMessages, ApiEndpoints, TransactionType, PaymentSteps, LoginTypes, PaymentStatus, Pricing, PaymentTypes } from '../../constant';
import { User, Competition } from '../../model'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs/Observable';
/**
 * import services
 */
import { CookieManagerService, ErrorManagerService, HttpClientService, CustomObserverService, GoogleService, ShoppingCartService, LoginRedirectService, RegistrationFeeService } from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { ComponentCanDeactivate } from '../../login/services/route-deactivate';
import { ItemsCheckout } from '../../model/itemsCheckout';

import swal from 'sweetalert2';
import { CookieService } from 'ngx-cookie-service';
import { SubscriptionInfoService } from '../../subscription-packages/subscription-info-service.service';
import { LoginGuardService } from '../../login/services/login-guard.service';
import { async } from 'q';
//import { CompetitionPopupComponent } from '../../../shared/popup/competition-popup/competition-popup.component';
import { resolve } from 'url';




declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: '../views/home.component.html',
  styleUrls: ['../../../css/home.component.css', '../../../css/paper-sets.component.css'],
  providers: [
    GoogleService
  ],
})
export class HomeComponent implements OnInit, OnChanges {

  @Output() getpaymentDetils: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isFinilize: boolean = true;
  /**
   * Basic Declarations
   */
  public newUser: User = new User();
  public authTypes: Object = AuthTypes;
  public username: Object;
  public user: any;
  public translatedText: string;
  public supportedLangs: any[];
  public defoltLanguage: string = 'en';
  public payObject: any;
  public redirectionUrl: string;
  public modalName: any;
  public bagroudClass: any = '';
  public setCollectionTips: string;
  public isShow: boolean = true;
  public version: string;
  public districts: Array<Object> = [];
  public isMobile: boolean = false;
  public points: any = '0';
  public isChrome: boolean = false;
  public cartItemsArray: Array<ItemsCheckout>;
  public totalPrice: number = 0;
  public itemLength: number = 0;
  public click: boolean = false;
  public discountAmount: number = 0;
  public isOpen: boolean = $("#hu").is(":visible");
  public isRemoveCartItem: boolean = false;
  public navIsFixed: boolean = false;
  public isPromo: boolean = false;
  public isMenuHide: boolean = false;
  public isMenuHideBackButton: boolean = true;
  public imageProfile: any;
  public backHide: boolean = false;
  public showSubscriptionInfoMsg: boolean = false;
  public paymentType: any;
  public currentPaymentType: string;

  public pricingModel = Pricing.model;
  public hotline: string;
  public aboutUs: any;
  public languages = LanguageSelector;
  public selectedLanguage = "si";
  public tutorial = tutorialVideo;
  public tutorialUrl;

  popupModal: any;
  public competition: any;
  keys: String[];
  public showVideo = false;

  value: string;
  constructor(
    private cookieService: CookieService,
    private route: ActivatedRoute,
    public toastr: ToastsManager,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService,
    private translateService: TranslateService,
    private httpClientService: HttpClientService,
    private localStorageService: LocalStorageService,
    private customObserverService: CustomObserverService,
    private shoppingCartService: ShoppingCartService,
    private router: Router, public googleService: GoogleService,
    private loginRedirectService: LoginRedirectService,
    private registrationFeeService: RegistrationFeeService,
    private subscriptionInfoService: SubscriptionInfoService,
    private loginGuardService: LoginGuardService,
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.route
      .queryParams
      .subscribe((params: any) => {
        this.payObject = params;
      });

    this.router.events.subscribe((val) => {
      this.customObserverService.setClassName('');
    });

    this.customObserverService.missionAnnounced$.subscribe(value => {
      let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);
      this.user = userObj ? JSON.parse(userObj.toString()) : null;
      if (this.user) {
        this.user.image = value;
      }
    });
    this.customObserverService.name$.subscribe(value => {
      this.username = value;
    });
    this.customObserverService.points$.subscribe(value => {
      this.points = value;
    });

    this.customObserverService.paymentCode$.subscribe(value => {
      this.isMenuHide = value;
      this.backHide = !value;
    });

    this.customObserverService.registrationFee$.subscribe(value => {
      this.backHide = value;
    });

    this.customObserverService.setItemId$.subscribe(value => {
      this.getCartItems();
    });

    this.customObserverService.subscriptionInfoMsg$.subscribe(value => {
      this.showSubscriptionInfoMsg = value;
    });

    this.customObserverService.currentPaymentType$.subscribe(value => {
      this.currentPaymentType = value;
    });

    this.currentPaymentType = this.localStorageService.get(CookieNames.PaymentModel) ? this.localStorageService.get(CookieNames.PaymentModel).toString() : '';

    //Should uncomment for paper price model
    // if(this.currentPaymentType == PaymentModel.NonSubscription){
    this.shoppingCartService.getItemsLength()
      .subscribe(res => {
        if (res != null) {
          this.isOpen = $("#hu").is(":visible");
          let oldItemLength = this.itemLength;
          this.getCartItems();
          this.itemLength = res.length;
          if (!this.isOpen) {
            this.swingCart();
          }
          if (this.itemLength > oldItemLength) {
            if (this.itemLength > 1 && this.isOpen) {
              this.shoppingCartService.resetTimer();
            }

          }
        }
      });
    this.getCartItems();
    // }


    let that = this;
    this.customObserverService.alert$.subscribe((value: any) => {
      this.isShow = value.isShow;
      this.isPromo = !value.isShow;
      if (!value.isShow && document.getElementById('news-section')) {
        document.getElementById('news-section').style.display = 'none';
      }
      else if (!value.isOnGoing && value.isShow) {
        document.getElementById('news-section').style.display = 'block';
      }
    });

    this.aboutUs = this.localStorageService.get("ABOUTUS");
    this.hotline = this.aboutUs ? this.aboutUs.contact : this.getPartners();

  }

  closeInfoPopup() {
    this.cookieManagerService.setCookie("isPopupClosed", "true", false, 0.5);
  }

  getChromeVersion() {
    var raw = navigator.userAgent.includes('Chrome');
    this.isChrome = raw ? raw : false;
    // return raw ? parseInt(raw[2], 10) : false;
  }


  showSuccess(message: string) {
    this.toastr.success(message, AlertMessages.success);
  }

  showError(message: string) {
    this.toastr.warning(message, AlertMessages.error);
  }


  isActivate() {
    this.isFinilize = true;
  }

  /**
   * Set the current language to the hole app
   */
  isCurrentLang(lang: string) {
    return lang === this.translateService.currentLang;
  }

  error() {
    this.httpClientService.get(ApiEndpoints.crash).subscribe(response => {

    }, error => {
      this.ErrorManagerService.setError(error);
    });
  }

  /**
   * Chang the language selector
   */
  selectLang(lang: string) {
    this.translateService.use(lang);
    this.customObserverService.setCurrentLanguage(lang);

  }

  ngOnInit() {

    // this.fetchcompetitions();
    // this.getLivePaperSetCount();
    // if this router is to pay registration fee
    if (this.router.url == BasicRoutes.registrationPayment) {
      //to hide the menue
      this.isMenuHide = true;
      //to hide back button once menue hide
      this.isMenuHideBackButton = false;
    }

    this.loginRedirectService.setRedirectPoint("registration");
    let trans = this.translateService;
    this.supportedLangs = LanguageSelector;

    if (this.tutorial && this.tutorial.show && this.cookieManagerService.getCookie("isPopupClosed", false) !== "true") {
      this.tutorialUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.tutorial.videoUrl);
      let innerWidth = window.innerWidth;

      if (innerWidth > 768) {
        $('#infoPopup').modal('show');
      }
    };
    // if (this.cookieManagerService.getCookie("isComPopupClosed", false) != "true") {
    //   //$('#competitionPopup').modal('show');
    // }
    // if( this.cookieManagerService.getCookie("isPopupClosed", false) != "true"){
    // };

    this.cookieManagerService.setCookie(CookieNames.paperStartStatus, 'false', false, 1);
    this.username = this.cookieManagerService.getCookie(CookieNames.name, false);
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);

    this.user = userObj ? JSON.parse(userObj.toString()) : null;
    if (this.user) {
      this.user.image = this.localStorageService.get(CookieNames.userImage);
      if (this.user.firstname) {
        this.username = this.user.firstname;
      } else {
        this.username = this.user.username;
      }
    }
    // check the subscription validity with the actual and storage values. If not match user will log out automatically
    this.checkSubscriptionValidity();
    // this.translateService.use(this.defoltLanguage);
    var language = this.cookieManagerService.getCookie("Lang", false);
    this.translateService.use(language ? language : defaultLanguage);
    this.selectedLanguage = language ? language : defaultLanguage;

    if (this.localStorageService.get(CookieNames.loginType) && this.cookieManagerService.getCookie(CookieNames.loginType, false) == "MOBILE") {
      this.isMobile = true;
    }
    this.points = this.cookieManagerService.getCookie(CookieNames.points, false);
    if (this.payObject.code) {
      if (this.router.url != BasicRoutes.mypapers) {
        this.isPayment(this.payObject.code);
      } else {
        this.toCheckLoginPopup();
      }
    } else {
      this.toCheckLoginPopup();
    }
    this.getDistrict();
    this.googleService.emitEvent("testCategory", "testAction", "testLabel", 10);
    this.customObserverService.setClassName('');
    this.vertions();
    this.getChromeVersion();
    this.cartItemsArray = this.shoppingCartService.allStorage();
    this.itemLength = this.shoppingCartService.itemsIDArray.length;

    // if user is loged
    if (this.user) {
      let removeCartItem = this.cookieManagerService.getCookie(CookieNames.isRemoveCartItem, false);
      if (removeCartItem) {
        this.isRemoveCartItem = true;
      }
    }
    if (this.isShow) {
      this.newsTips(); // comment becuase of giving error when not log in
    }

    this.paymentType = this.localStorageService.get("PAYMENT_TYPES");
    if (this.paymentType == null) {
      this.getPaymentTypes();
    }

  }

  getPaymentTypes() {
    this.httpClientService.get(ApiEndpoints.getPaymentTypes).subscribe(
      response => {
        if (response && response.paymentType) {
          this.localStorageService.set("PAYMENT_TYPES", response.paymentType);
          this.paymentType = this.localStorageService.get("PAYMENT_TYPES");
        }
      }, error => {

      });
  }

  checkSubscriptionValidity() {
    if (this.currentPaymentType == PaymentModel.Subscription && this.user && (this.user.mobile || this.user.username)) {
      this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.checkUserSubscriptionValidity, { [ApiEndpoints.mobile]: this.user.username ? this.user.username : this.user.mobile }), null).subscribe(response => {
        if (response && response.userStatus && response.userStatus.status === "SUBSCRIBED") {
          if (!this.loginGuardService.checkSubscriptionValidity(response.userStatus.packageId, this.subscriptionInfoService.getUserSubscribedPackage())) {
            swal({
              title: this.translateService.instant('ERROR'),
              html: this.translateService.instant("PLEASE_LOGIN_AGAIN"),
              type: 'info'
            });
            this.logout();
          }
          else {
            this.subscriptionInfoService.toggleSubscriptionPopup();
          }
        }
      });
    }

  }

  getDistrict() {
    let distric: any = this.cookieManagerService.getCookie(CookieNames.district, true);
    let that = this;
    if (distric && distric.isDistrictNeed) {
      this.loadDistricts().then((response: any) => {

        var toObject = (arr) => {
          var rv = {};
          for (var i = 0; i < arr.length; ++i)
            rv[arr[i].key] = arr[i].value;
          return rv;
        }
        swal({
          title: that.translateService.instant('SELECT_YOUR_DISTRICT'),
          text: that.translateService.instant('SELECT_DETAILS'),
          input: 'select',
          inputOptions: toObject(response),
          // inputPlaceholder: that.translateService.instant('DISTRICT'),
          // confirmButtonText: that.translateService.instant('BTN_CONFIRM'),
          // inputValidator: function (value) {
          //   return new Promise(function (resolve, reject) {
          //     if (!value) {
          //       reject(that.translateService.instant('SELECT_YOUR_DISTRICT'));
          //     }

          //     that.httpClientService.authPut(ApiEndpoints.districts, { key: value }).subscribe(
          //       res => {
          //         that.cookieManagerService.removeCookie(CookieNames.district);
          //         resolve();
          //       }, error => {
          //         reject(that.translateService.instant('DISTRIC_RESPONCE_ERROR'));
          //       });
          //   });
          //   }
          // }).then(function (result) {

        }).catch(e => {

        });
      });
    }
  }

  loadDistricts() {
    return new Promise((resolve, reject) => {
      this.httpClientService.get(ApiEndpoints.getDistricts).subscribe(
        response => {
          if (response && response.length != 0) {
            resolve(response);
          } else {
            reject();
          }

        }, error => {
          reject();
        });
    });
  }

  isPayment(id) {
    this.shoppingCartService.clearAll();
    let translateService = this.translateService;
    this.httpClientService.authGet(ApiEndpoints.checkPayment + id, null).subscribe(response => {
      let transaction = (response.transaction || false);
      if ((response.transaction || false)) {
        if (this.isMobile) {
          window.location.href = ApiEndpoints.MOBILE_APP_URL + '/' + id;
          window.close();
        } else {
          if (transaction.currentAction == PaymentStatus.PENDING) {
            swal({
              title: translateService.instant('CANCEL_BUY_PAPER'),
              text: translateService.instant('TRY_AGAIN_ADDTOBILL'),
              confirmButtonText: translateService.instant('NOINT_TRY_AGAIN')
            })
          } else {
            swal({
              title: translateService.instant('SUCCESS_BUY_PAPER'),
              text: translateService.instant('SUCCESS_BUY_PAPER_TEXT'),
              confirmButtonText: translateService.instant('SW_MESSAGE1'),
            });
            // to set user object and authentication token
            this.paymentAfter(response.user, response.token);
          }
        }
        // clear the shoping details
        this.shoppingCartService.clearAll();
        this.cookieManagerService.removeCookie(CookieNames.isRemoveCartItem, '/');
        this.cookieManagerService.removeCookie(CookieNames.registrationFee, '/');
        this.cookieManagerService.removeCookie(CookieNames.registrationToken, '/');
        this.cookieManagerService.removeCookie(CookieNames.registrationCode, '/');
      } else {
        if ((transaction.type || false)) {
          swal({
            title: translateService.instant(TransactionType[transaction.type].title),
            text: translateService.instant(TransactionType[transaction.type].text)
          })
        }
      }
    }, error => {
      swal({
        title: translateService.instant('CANCEL_BUY_PAPER'),
        text: error.message
      })
    });
  }

  /**
   * Save user login details on Cookies and Localstorage with given User object and tokens
   * with returns from authenticate api
   *
   * @param {User} user
   * @memberof AppLoginComponent
   */
  paymentAfter(user: User, token) {
    if (user && user.image) {
      this.imageProfile = user.image;
    } else {
      this.imageProfile = '/assets/img/default-avatar.svg';
    }
    //this.localStorageService.remove(CookieNames.userImage);
    this.localStorageService.set(CookieNames.userImage, this.imageProfile);
    let userDetails = user;
    userDetails.image = '';
    this.cookieManagerService.setCookie(CookieNames.userobj, JSON.stringify(userDetails));
    this.cookieManagerService.setCookie(CookieNames.loginKey, AuthTypes.tokenPrefix + token, false);
    this.cookieManagerService.setCookie(CookieNames.loginType, LoginTypes.web, false);
    this.localStorageService.set(CookieNames.loginType, LoginTypes.web);
    if (user.firstname) {
      this.customObserverService.setName(user.firstname);
    } else {
      this.customObserverService.setName(user.username);
    }
    //this.getpaymentDetils.emit(true);
    this.registrationFeeService.setSendUserExitDetials(true);
    this.customObserverService.setData(this.imageProfile);
    this.toCheckLoginPopup();
  }

  ngOnChanges(changes: { [propKey: string]: any }) {
    let log: string[] = [];
  }

  newsTips() {

    this.httpClientService.get(ApiEndpoints.offerImage).subscribe(response => {
      if (Object.keys(response).length != 0) {
        this.setCollectionTips = response.description;
        this.customObserverService.hideNewsAlert({ isOnGoing: false, isShow: true });
        if (response.isDiscountOffer && !response.isAnnouncement) {
          this.discountAmount = response.discountRate
        }
      } else {
        this.customObserverService.hideNewsAlert({ isOnGoing: false, isShow: false });
      }
    }, error => {
      this.customObserverService.hideNewsAlert({ isOnGoing: false, isShow: false });
    });
  }

  vertions() {
    this.httpClientService.authGet(ApiEndpoints.versions, null).subscribe(
      res => {
        this.version = res.version;
      },
      error => {
        console.log(error);
      });
  }

  getPartners() {

    this.commonService.getPartners().then((response: any) => {
      this.aboutUs = response;
      this.hotline = this.aboutUs ? this.aboutUs.contact : null;
    });
  }

  closeNews() {
    this.isPromo = true;
    // $(".floating").removeClass();
    // $(".banner").removeClass();
    // $(".display-none").removeClass();
    this.customObserverService.hideNewsAlert({ isOnGoing: false, isShow: false });
  }

  closePromos() {


  }

  getCartItems() {
    this.shoppingCartService.itemsCheckout.subscribe((response) => {
      this.cartItemsArray = response;
      this.totalPrice = this.shoppingCartService.returnTotalPrice();
    });
  }

  removeItemCheckout(item_id) {
    this.customObserverService.setItemStatus(item_id);
    this.shoppingCartService.removeItemsCheckout(item_id);
    this.getCartItems();
  }
  ngAfterViewInit() {


    this.popupModal = $('#competitionPopup');

    this.totalPrice = this.shoppingCartService.returnTotalPrice();
    let _that = this;
    $('body').click(function (evt) {
      if (!(($(evt.target).closest('#hu').length) || ($(evt.target).closest('#bag').length) || ($(evt.target).closest('#cart-wrap').length) || ($(evt.target).closest('#pointer').length) || ($(evt.target).closest('#yes-button').length))) {
        _that.isOpen = $("#hu").is(":visible");
        if (_that.isOpen) {
          $("#hu").hide();
          _that.shoppingCartService.clearTimer();
          _that.isOpen = false;
          return;
        }
      }
    });
  }
  clickOn() {
    this.isOpen = $("#hu").is(":visible");
    if (this.isOpen) {
      $("#hu").hide();
    } else {
      $("#hu").show();
    }
    this.customObserverService.setPaymentFlowIcon(PaymentSteps.cart);
  }
  swingCart() {
    $('#bag .cart-bag').addClass('rotate').delay(1000).queue(function (next) {
      $(this).removeClass('rotate');
      next();
    })
  }
  /**
   * Logout grom the application
   * edit
   * kaushalya
   * 2017-10-26
   * set path to remove the cookies
   */
  logout() {

    this.cookieService.delete(CookieNames.loginKey, '/');
    this.cookieService.delete(CookieNames.userobj, '/');
    this.cookieService.deleteAll('/');
    this.username = null;

    this.localStorageService.clearAll();
    this.localStorageService.remove(CookieNames.userImage);
    this.shoppingCartService.clearPersonelItems();
    this.router.navigate([BasicRoutes.loginRedirect]);
    this.cookieManagerService.removeCookie(CookieNames.isRemoveCartItem, '/');
    this.subscriptionInfoService.setCurrentSubscriptionPackage("");

  }

  backToMobile() {
    window.open(ApiEndpoints.MOBILE_REDIRECT_URL);
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number > 100) {
      this.navIsFixed = true;
    } else if (this.navIsFixed && number < 10) {
      this.navIsFixed = false;
    }
  }

  ngDoCheck() {
    if (!this.router.url.startsWith(BasicRoutes.paymentOptions) && !this.router.url.startsWith(BasicRoutes.paymentMobile) &&
      !this.router.url.startsWith(BasicRoutes.registrationPaymentMobile) && this.router.url != BasicRoutes.registrationPayment) {
      //to hide the menue
      this.isMenuHide = false;
      //to hide back button once menue hide
      this.isMenuHideBackButton = true;
    }
  }

  toCheckLoginPopup() {
    if (this.router.url == BasicRoutes.mypapers) {
      let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);

      this.user = userObj ? JSON.parse(userObj.toString()) : false;
      if (!this.user) {
        // show the login pop up
        $('#log-in-pop').modal('show');
      }
      else {
        var isDialogNumber = this.commonService.isDialogMobileNumber(this.user.mobile);
        if (isDialogNumber) {
          this.subscriptionInfoService.toggleSubscriptionPopup();
        }
      }
    }
  }

  public livePaperSetCount = 0;
  // getLivePaperSetCount(){

  // var url = ApiEndpoints.getOnlinePaperSets;
  //   this.httpClientService.authGet(ApiEndpoints.replaceParms(url, { [ApiEndpoints.paperType]: 'ONLINE_EXAM', [ApiEndpoints.pageNumber]: 1, [ApiEndpoints.paperUserStatus]: 'undefined' }), null).subscribe(
  //     res => {
  //         if ((res.papersets || false)) {
  //           this.livePaperSetCount = res.papersets.length === 0 ? this.livePaperSetCount : res.count;
  //           if( this.livePaperSetCount > 0 ){
  //             this.router.navigate(['home/exams/online']);
  //           }
  //           else{
  //             this.router.navigate(['home/exams']);
  //           }
  //         }
  //         else{
  //           this.router.navigate(['home/exams']);
  //         }
  //     }, e => {
  //     });
  // }



  changeLanguage(value) {

    this.selectedLanguage = value;
    this.cookieManagerService.setCookie("Lang", value);
    this.translateService.use(this.cookieManagerService.getCookie("Lang", false));
    this.customObserverService.setCurrentLanguage(this.selectedLanguage);
    // $('#infoPopup').modal('show');

    // debugger;



    if (this.router.url === '/home/exams/revision' || this.router.url === '/home/exams/online') {
      this.router.navigate(['home/exams']);
    }
    else if (this.router.url === '/home/exams') {
      this.router.navigate(['home/exams/revision']);
    }

    else if (this.router.url === '/home/exams') {
      this.router.navigate(['home/exams/revision']);
    }

  }
  // modalClose() {
  //   this.popupModal.modal('hide');
  // }
  fetchComp(): Observable<any> {
    // tslint:disable-next-line: prefer-const
    let language = this.cookieManagerService.getCookie('Lang', false);

    return this.httpClientService.get(environment.ENV.apiBaseUrl + 'admin/competition/' + (language ? language : defaultLanguage));
  }
  fetchcompetitions() {
    this.fetchComp().subscribe(
      competitions => {
        console.log(competitions);
        if (competitions !== 'null') {

          this.competition = competitions;
          // tslint:disable-next-line: no-unused-expression
          this.competition ? $('#competitionPopup').modal('show') : '';

        }


      }, error => {
        console.log(error);
        this.ErrorManagerService.setError(error);
      });
  }



}





// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/home/components/home.component.ts